module.exports = __webpack_public_path__ + "images/pages/for_business/pc/img01_73567152a37704964622b9492ab0c560.png";